export default "__VITE_ASSET__veQ2AzMWG1LN0$lYRxQ8qw__"